import TableCells from 'components/TableCells';
import { Column } from 'react-table';

import { ParsedAdvertisersDomainStatsData } from '../../types';

export const defaultSort = [{ id: 'adPlayed', desc: true }];

const columns: ReadonlyArray<Column<ParsedAdvertisersDomainStatsData>> = [
  {
    Cell: TableCells.TextWithTooltipCell,
    Header: <TableCells.HeaderCell accessor="domain" multiline />,
    accessor: 'domain',
    sortType: 'string',
  },
  {
    Cell: TableCells.NumericCell,
    Header: <TableCells.HeaderCell accessor="spEngaged" />,
    accessor: 'spEngaged',
    sortType: 'number',
    width: '200px',
  },
];

export default columns;
